import { gql } from '@apollo/client';

export default gql`
  mutation addMerchantIdToAcquirerMutation($input: MerchantIdInput!) {
    addMerchantIdToAcquirer(input: $input) {
      id
    }
  }
`;
